import React, { useEffect } from 'react'

import { Label } from 'shared/ui'

import LinkedJiraCloudIssue from './LinkedJiraCloudIssue'

export default function LinkedJiraCloudIssues({
  doFetchJiraCloudIssues,
  issues = [],
  sites = [],
}) {
  if (issues.length === 0) return null
  const issueIds = issues.map(({ externalId }) => externalId)
  useEffect(
    () => {
      doFetchJiraCloudIssues(issueIds)
    },
    [sites.map(({ id }) => id).join(), issueIds.join()]
  )
  const initiallyActive = issues.length === 1
  return (
    <React.Fragment>
      <Label size="small">Linked Issues</Label>
      {issues.map(issue => {
        return (
          issue && (
            <LinkedJiraCloudIssue
              issue={issue}
              initiallyActive={initiallyActive}
              key={issue.id}
            />
          )
        )
      })}
    </React.Fragment>
  )
}
